// 注意: 这里我们不能直接使用 import，因为这是 JavaScript 而不是 TypeScript
// 所以我们将 Pathnames 类型的使用注释掉了

export const locales = ['en', 'zh', 'ja', 'ko', 'es', 'fr', 'de', 'ar', 'th', 'pl', 'tr', 'cs', 'pt'];

export const languages = [
  {
    code: "en-US",
    lang: "en",
    language: "English",
    languageInChineseSimple: "英语"
  },
  {
    code: "zh-CN",
    lang: "zh",
    language: "简体中文",
    languageInChineseSimple: "简体中文"
  },
  {
    code: "ja-JP",
    lang: "ja",
    language: "日本語",
    languageInChineseSimple: "日语"
  },
  {
    code: "ko-KR",
    lang: "ko",
    language: "한국어",
    languageInChineseSimple: "韩语"
  },
  {
    code: "es-ES",
    lang: "es",
    language: "Español",
    languageInChineseSimple: "西班牙语"
  },
  {
    code: "fr-FR",
    lang: "fr",
    language: "Français",
    languageInChineseSimple: "法语"
  },
  {
    code: "de-DE",
    lang: "de",
    language: "Deutsch",
    languageInChineseSimple: "德语"
  },
  {
    code: "ar-SA",
    lang: "ar",
    language: "العربية",
    languageInChineseSimple: "阿拉伯语"
  },
  {
    code: "th-TH",
    lang: "th",
    language: "ไทย",
    languageInChineseSimple: "泰语"
  },
  {
    code: "pl-PL",
    lang: "pl",
    language: "Polski",
    languageInChineseSimple: "波兰语"
  },
  {
    code: "tr-TR",
    lang: "tr",
    language: "Türkçe",
    languageInChineseSimple: "土耳其语"
  },
  {
    code: "cs-CZ",
    lang: "cs",
    language: "Čeština",
    languageInChineseSimple: "捷克语"
  },
  {
    code: "pt-PT",
    lang: "pt",
    language: "Português",
    languageInChineseSimple: "葡萄牙语"
  }
];

export const languagesEn = [
  {
    code: "en-US",
    lang: "en",
    language: "English",
    languageInChineseSimple: "英语"
  }
];

export const pathnames = {
  '/': '/',
}; // 注意：我们移除了 satisfies Pathnames<typeof locales>，因为这是 TypeScript 语法

// Use the default: `always`，设置为 as-needed可不显示默认路由
export const localePrefix = 'as-needed';

// 注意：我们移除了 AppPathnames 类型定义，因为这是 TypeScript 语法

export const getLanguageByLang = (lang) => {
  for (let i = 0; i < languages.length; i++) {
    if (lang == languages[i].lang) {
      return languages[i];
    }
  }
  return languages[0];
};

export const langCode = ['en', 'zh'];

export const defaultLocale = "en";

export const localeNames = {
  en: "🇺🇸 English",
  zh: "🇨🇳 中文",
  ja: "🇯🇵 日本語",
  ko: "🇰🇷 한국어",
  es: "🇪🇸 Español",
  fr: "🇫🇷 Français",
  de: "🇩🇪 Deutsch",
  ru: "🇷🇺 Русский",
  ar: "🇸🇦 العربية",
  th: "🇹🇭 ไทย",
  pl: "🇵🇱 Polski",
  tr: "🇹🇷 Türkçe",
  cs: "🇨🇿 Čeština",
  pt: "🇵🇹 Português"
};